import { BulkMatrixType } from "../../services/cellcast.v2.types";
import { FormatNumberWithDecimal } from "../Utils/_helpers/string";
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import React from 'react'

interface MatrixCardProps {
  value: number
  type: string
  growthRate: number
  tooltipText?: string
}

const iconMap: Record<BulkMatrixType, string> = {
  [BulkMatrixType.bounceRate]: '/media/svg/matrix/bounce.svg',
  [BulkMatrixType.ctrRate]: '/media/svg/matrix/ctr.svg',
  [BulkMatrixType.replyRate]: '/media/svg/matrix/reply.svg',
  [BulkMatrixType.unsubscribeRate]: '/media/svg/matrix/unsubscribe.svg',
};

const typeLabels: Record<BulkMatrixType, string> = {
  [BulkMatrixType.bounceRate]: 'Bounce Rate',
  [BulkMatrixType.ctrRate]: 'Click-Through Rate (CTR)',
  [BulkMatrixType.replyRate]: 'Reply Rate',
  [BulkMatrixType.unsubscribeRate]: 'Unsubscribe Rate',
};

const MatrixCard: React.FC<MatrixCardProps> = ({ value, type, growthRate, tooltipText }) => {
  return (
    <div className='mt-3 p-6 shadow-sm rounded-4 bg-white text-left d-flex flex-column'>
      <div className='mb-6'>
        <img
          src={iconMap[type as BulkMatrixType]}
          alt={typeLabels[type as BulkMatrixType]}
          width={24}
          height={24}
        />
      </div>
      <h3 className='mb-4' style={{fontSize: '38px', fontWeight: '700'}}>
        {FormatNumberWithDecimal(value)}%
      </h3>
      <span className='fs-5 text-black mb-3'>{typeLabels[type as BulkMatrixType]}
        <OverlayTrigger
        placement='bottom'
        delay={{show: 250, hide: 400}}
        overlay={<Tooltip id='tooltip-bottom'>{tooltipText}</Tooltip>}
        >
          <i className='bi bi-info-circle ms-2 text-muted'></i>
        </OverlayTrigger>
      </span>
      <span className='text-success fw-semibold'>
        {FormatNumberWithDecimal(growthRate)}% from last month
      </span>
    </div>
  )
};

export default MatrixCard;
